export default function FooterLogos() {
  return (
    <section className="bg-white dark:bg-dark-900/50 py-10 border-t border-gray-200 dark:border-dark-700">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="bg-white dark:bg-white rounded-xl p-4 sm:p-6 shadow-sm">
            <img
              src="/images/footer/LDL_Logos.jpg"
              alt="Legal deposit library partners: British Library, Trinity College Dublin, Bodleian Libraries (University of Oxford), University of Cambridge, National Library of Scotland, National Library of Wales"
              className="w-full h-auto block"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
